<template>
  <div class="w-full flex p-2 grow pt-0 min-h-[20em] flex-col overflow-auto">
    <div class="flex p-4 relative !my-2">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
      </svg>
      <input
        v-model="search"
        class="outline-none absolute rounded-xl border border-gray-200 h-full w-full left-0 top-0 pl-12 bg-transparent focus:outline-blue-600"
        placeholder="Search key"
        ref="searchEl"
      >
    </div>
    <ul v-if="!loading" class="divide-y divide-gray-100 disable-ske" role="list">
      <CategoryCheckbox
        v-for="cat in filteredCategories"
        :key="cat.id"
        :search="search"

        v-bind="{...$props, ...cat, blockId: id}"
      />
    </ul>
    <ul v-else class="divide-y divide-gray-100" role="list">
      <CategoryCheckbox
        v-for="cat in placeholder"
        :key="cat"

        :name="cat"
        :children="[]"
      />
    </ul>
  </div>
</template>

<script>

import { mapGetters } from "vuex"

import CategoryCheckbox from "./CategoryCheckbox.vue"

export default {
  components: {
    CategoryCheckbox,
  },
  props: ['id', 'title', 'role', 'config', 'content', 'configuration'],
  data() {
    return {
      loading: true,
      search: "",
      categories: [],
      placeholder: ['asht', 'asiohtnasten', 'thsshtathst', 'ashtastena sthnai', 'ashtast', 'ashtasth', 'ashtasht', 'wrduwp;drfw', 'ashtths'],
    }
  },
  async created() {
    this.loading = true
    this.categories = (await this.$store.dispatch("cachedGet", {
      endpoint: `${this.link}/rest/V1/editor/list-available-categories`,
      headers: { Cookie: 'environment=editor' },
    })).data || []
    this.loading = false
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink'
    }),

    filteredCategories() {
      const search = this.search

      if (!search) return this.categories
      return this.categories.filter(cat => cat.name.toLowerCase().includes(search.toLowerCase()))
    },
  },
}

</script>

